import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

// Components
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      position: 'relative',
    },
    inputRow: {
      display: 'flex',
      alignItems: 'center',
    },
    inputCopy: {
      marginRight: theme.spacing(4),
    },
    numberInput: {
      minWidth: 128,
    },
  };
};

function Export({ classes, onChange, errorMessage, value }) {
  const limit = _get(value, 'limit', 1000);
  const enabled = _get(value, 'enabled', false);

  function handleChangeLimit(e) {
    const value = e.currentTarget.value;
    const parseValue = parseInt(value, 10);
    const limit = isNaN(parseValue) ? value : parseValue;

    onChange('client.settings.export.limit', limit);
  }

  function handleChangeEnabled(e, isEnabled) {
    onChange('client.settings.export.enabled', isEnabled);
  }

  return (
    <Card>
      <CardHeader
        title="Exporting Results"
        action={
          <Switch
            inputProps={{ 'aria-label': 'export switch' }}
            onChange={handleChangeEnabled}
            checked={enabled}
          />
        }
        subheader="Allow users to export a CSV file with data from their search result. Our maximum for the
            number of people that may be exported is 1000, but you may use a lower limit."
      />

      <Divider />
      <CardContent style={{ paddingTop: 0, marginTop: 15 }}>
        <div className={classes.inputRow}>
          <div className={classes.inputCopy}>Export Limit</div>
          <TextField
            id="export-limit"
            disabled={!enabled}
            error={!!errorMessage}
            helperText={errorMessage}
            value={limit}
            className={classes.numberInput}
            onChange={handleChangeLimit}
          />
        </div>
      </CardContent>
    </Card>
  );
}

Export.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    limit: PropTypes.number,
    enabled: PropTypes.bool,
  }),
  errorMessage: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Export);
